import React, { useState } from 'react';
import { Container, Typography, TextField, Button } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../utils/api';

function ResetPassword() {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState('');
  const navigate = useNavigate();

  console.log('Reset token:', token);
  console.log('New password:', newPassword);

  const handleReset = async () => {
    try {
      const response = await api.post('/auth/reset-password/confirm', { token, newPassword });
      console.log('Password reset successful:', response.data);
      navigate('/signin'); // Redirect to the login page
    } catch (error) {
      console.error('Error resetting password:', error.response.data); // Log the error response
      // Handle error (e.g., show error message)
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Reset Password
      </Typography>
      <TextField
        label="New Password"
        variant="outlined"
        fullWidth
        margin="normal"
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />
      <Button variant="contained" color="primary" onClick={handleReset} fullWidth>
        Reset Password
      </Button>
    </Container>
  );
}

export default ResetPassword; 